import {  Injectable } from '@angular/core';
import { Wizard } from 'src/app/core/wizard/wizard';
import { SqftWarningComponent } from './sqft-warning/sqft-warning.component';

// new-popup-wizard.ts
@Injectable({
  providedIn: 'root',
})
export class SqftWarningWizard extends Wizard<any> {
  key = 'sqft-warning';
  pageTypeMap: any = {
    'sqft-warning': SqftWarningComponent
  };

  startingPageKey = 'sqft-warning';
  model: any = {};


  constructor() {
    super();
  }
}
